module.exports = __webpack_public_path__ + "static/media/done.df4f9ee6.svg";